/* 
 *  This file app-routing.module.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from './global/guard/auth-guard-service';
import { SuperUserResolverService } from './global/services/super-user.resolver.service';

export const routes: Routes = [
  { path: '', redirectTo: 'signup', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./modules/customer-auth/customer-auth.component').then(m => m.CustomerAuthComponent) },
  { path: 'signup', loadComponent: () => import('./modules/customer-auth/customer-auth.component').then(m => m.CustomerAuthComponent) },
  {
    path: 'customer-setup/home', loadComponent: () => import('./modules/product-management/setup/customer/customer.component').then(m => m.CustomerComponent),
      canLoad: [AuthGuardService], resolve: {
        superUser: SuperUserResolverService
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


